/**
 * Created by Youhn on 2017/9/11.
 */
let apiUrl = 'http://localhost:7737/api'
// let apiUrl = 'http://zapi.yesfree.cn/api'
const jwtSecret = 'zdsdf28fa4d48d2f86c812aa8ac23zds'
const zdsCategory = {ZSQ: 'Z009', ZSJ: 'Z00B', ZLW: 'Z00601', ZYHP: 'Z006'}
// 大类ZSQ=Z009 镶嵌类；ZYHP=Z006 易耗品、礼品;ZSJ=Z00B素金,Z00601礼物？
if (process.env.NODE_ENV === 'development') {
  apiUrl = 'http://zapi.yesfree.cn/api'
  apiUrl = 'https://wxddapi.chowtaiseng.com/api'
  apiUrl = 'http://47.100.216.192:8061/api'
} else if (process.env.NODE_ENV === 'production') {
  apiUrl = 'http://zapi.yesfree.cn/api'
  apiUrl = 'https://wxddapi.chowtaiseng.com/api' // 正式服
//  apiUrl = 'http://47.100.216.192:8061/api' // 测试服
}
export {
  apiUrl,
  jwtSecret,
  zdsCategory
}



// WEBPACK FOOTER //
// ./src/config/env.js